import Link from "next/link";

const LinkButton = ({text, url}) => {

    return (
        <>
            <div className="buy-now-btn">
                <Link
                    className="rbt-btn btn-gradient icon-hover w-50 text-center"
                    href={url}
                    target="_blank"
                >
                    <span className="btn-text">{text}</span>
                    <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                    </span>
                </Link>
            </div>

        </>
    );
};

export default LinkButton;